


































































































import {
  ComponentInternalInstance,
  getCurrentInstance,
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import { DialogPlugin } from 'tdesign-vue';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { httpUrl } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      required: false,
      type: Object,
      default: {
        tenantName: '',
        serviceAccount: '',
      },
    },
    bindSSO: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    RemoveConfigConfirm,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const showModifyPage = ref(false);
    const organizationConfig = reactive<any>({
      tenantName: '',
      serviceAccount: '',
    });
    const configFormTips = reactive({
      tenantName: '',
      serviceAccount: '',
      validate: {
        code: 'none',
        message: i18n_t('未关联'),
      },
    });
    const showTenantText = ref(false);
    /**
     * 配置条件未完成
     */
    const configUnFinished = computed(() => {
      const allow =
        organizationConfig.tenantName &&
        organizationConfig.serviceAccount &&
        configFormTips.tenantName === '' &&
        configFormTips.serviceAccount === '';
      return !allow;
    });
    const methods = {
      init() {
        configFormTips.tenantName = '';
        configFormTips.serviceAccount = '';
        configFormTips.validate = {
          code: 'none',
          message: i18n_t('未关联'),
        };
        if (!props.initData.tenantName || _.isEmpty(props.initData.serviceAccount)) {
          showModifyPage.value = true;
        } else {
          showModifyPage.value = false;
        }
        organizationConfig.tenantName = props.initData.tenantName;
        organizationConfig.serviceAccount = props.initData.serviceAccount
          ? JSON.stringify(props.initData.serviceAccount)
          : '';
        showTenantText.value = !!props.initData.tenantName && props.bindSSO;
      },
      modifyAssociation() {
        showModifyPage.value = true;
      },
      validateConfigForm(type: string) {
        switch (type) {
          case 'tenantName':
            configFormTips.tenantName = organizationConfig.tenantName === '' ? i18n_t('不能为空') : '';
            break;
          case 'serviceAccount':
            if (organizationConfig.serviceAccount === '') {
              configFormTips.serviceAccount = i18n_t('不能为空');
            } else {
              try {
                if (typeof JSON.parse(organizationConfig.serviceAccount) === 'object') {
                  configFormTips.serviceAccount = '';
                }
              } catch (e) {
                configFormTips.serviceAccount = i18n_t('格式不正确');
              }
            }
            break;
          default:
            break;
        }
      },
      throttleValidateConfigForm: _.throttle((type: string) => {
        const isDiff = ['tenantName', 'serviceAccount'].some(key => organizationConfig[key] !== props.initData[key]);
        if (isDiff) {
          configFormTips.validate.code = 'none'; // 有改动清除测试结果
          configFormTips.validate.message = '';
        }
        methods.validateConfigForm(type);
      }, 500),
      async saveOrgAssociation() {
        try {
          const params = {
            type: 'sync',
            tenantName: organizationConfig.tenantName,
            serviceAccount: organizationConfig.serviceAccount
              ? JSON.parse(organizationConfig.serviceAccount as string)
              : undefined,
          };
          await smh.userAPI.checkIDaasConfig(params as SMH.IDaasConfigParams);
          await smh.userAPI.updateIDaasConfig(params as SMH.IDaasConfigParams);
          configFormTips.validate.code = 'success';
          tips.success(i18n_t('配置生效'));
          context.emit('onSubmit', {
            ...organizationConfig,
            serviceAccount: JSON.parse(organizationConfig.serviceAccount as string),
          });
          innerShow.value = false;
        } catch (error) {
          configFormTips.validate.code = 'error';
          configFormTips.validate.message = i18n_t('配置失败，{slot1}', {
            slot1: formatError(error as MsgError),
          });
          tips.error(error as MsgError);
        }
      },
      confirmEditTenant() {
        const dialog = CustomDialog.confirm({
          header: i18n_t('是否编辑租户ID？'),
          body: i18n_t('你已经绑定了该租户ID的其他功能，如果重新编辑已关联的功能将会失效。'),
          theme: 'info',
          onConfirm: () => {
            showTenantText.value = false;
            if (dialog.hide) {
              dialog.hide();
            }
          },
        });
      },
      onClose() {
        innerShow.value = false;
      },
      openCofileGuide() {
        dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
      },
      removeConfirm() {
        methods.onClose();
        context.emit('refresh', 'idass-data');
      },
    };
    watch(innerShow, () => {
      if (innerShow.value) {
        methods.init();
      }
    });
    return {
      innerShow,
      showModifyPage,
      showTenantText,
      organizationConfig,
      configFormTips,
      configUnFinished,
      ...methods,
    };
  },
});
